'use client';
import React, { useContext, useState, forwardRef } from 'react';
import languageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';
import { SearchInput } from './search-input';
import { ResultsTable } from './results-table';
import { TableColumn } from '@/shared/components/Table/use-column';
import dayjs from 'dayjs';
import { SDSButton } from '@/app/product/[catalogNumber]/components/sds-button';

const DataSheets = forwardRef<HTMLInputElement>(function DataSheets(props, ref) {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'document-search');
  const [search, setSearch] = useState<string>();
  const [resetPageNo, setResetPageNumber] = useState<boolean>(false);
  const [showPopUp, setShowPopUp] = useState<boolean>(false);
  const [catalogArr, setCatalogArr] = useState<string[]>([]);

  const searchboxFunc = (key) => {
    setSearch(key);
    setResetPageNumber(true);
  };
  const getCatalogNo = (catalog) => {
    setShowPopUp(true);
    const catalogArr = catalog.map((item) => item.catalogNumber);
    setCatalogArr(catalogArr);
  };
  const closePopUp = () => {
    setShowPopUp(false);
    setCatalogArr([]);
  };
  const setResetPage = (val) => {
    setResetPageNumber(val);
  };
  const columns: TableColumn<any>[] = [
    {
      accessorKey: 'name',
      header: t('name'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        return (
          <a onClick={() => getCatalogNo(row.catalogNumberAndUrls)} className="flex cursor-pointer">
            <i className="icon-16-document-mono" />
            <p className="pl-2">{row.name}</p>
          </a>
        );
      },
    },
    {
      accessorKey: 'documentType',
      header: t('doc.type'),
      style: {
        minWidth: '200px',
      },
    },
    {
      accessorKey: 'date',
      header: t('date'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        const dateVal = row.date;
        const date = dateVal ? dayjs(dateVal).format('DD MMM YYYY') : '';
        return date;
      },
    },
    {
      accessorKey: 'catalogNumberAndUrls',
      header: t('catalog.no'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        const catalogArr = row.catalogNumberAndUrls.map((catalog) => catalog.catalogNumber);
        return catalogArr.toString();
      },
    },
  ];
  return (
    <>
      <SearchInput placeHolderTxt={t('sds.placeholder')} onClick={searchboxFunc} />
      <ResultsTable
        columns={columns}
        search={search}
        documentType="SDS"
        resetPage={resetPageNo}
        setResetPage={setResetPage}
      />
      {showPopUp && <SDSButton showPopUp={true} childCatalogNumbers={catalogArr} onClose={closePopUp} />}
    </>
  );
});
export { DataSheets };
